// Dados de acesso do app. A SENHA nunca é gravada pelo DigiPonto: quem guarda é o gerenciador de
// senhas do próprio celular (Google no Android / Chaves do iCloud no iPhone), criptografado pelo sistema.
// O app guarda só o token de sessão e o nome de usuário (para preencher o campo).
const ULTIMO_USUARIO = "digiponto_app_last_user";

export const ultimoUsuario = () => localStorage.getItem(ULTIMO_USUARIO) || "";

export function idadeTokenHoras(token) {
  try {
    const p = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    return (Date.now() / 1000 - (p.iat || 0)) / 3600;
  } catch (_) { return 0; }
}

// Android/Chrome: oferece salvar no Gerenciador de Senhas do Google.
// iPhone: o Safari/iOS oferece salvar nas Chaves do iCloud ao enviar o formulário de login.
export async function guardarAcesso(username, password) {
  localStorage.setItem(ULTIMO_USUARIO, username);
  try {
    if (window.PasswordCredential && navigator.credentials?.store) {
      await navigator.credentials.store(new window.PasswordCredential({ id: username, password, name: username }));
    }
  } catch (_) { /* usuário recusou ou navegador sem suporte */ }
}

// Preenchimento automático com a senha salva no celular (quando o sistema permite)
export async function lerAcessoSalvo() {
  try {
    if (window.PasswordCredential && navigator.credentials?.get) {
      const c = await navigator.credentials.get({ password: true, mediation: "optional" });
      if (c?.id && c?.password) return { username: c.id, password: c.password };
    }
  } catch (_) { /* sem suporte */ }
  return null;
}

export async function esquecerAcesso() {
  localStorage.removeItem(ULTIMO_USUARIO);
  try { await navigator.credentials?.preventSilentAccess?.(); } catch (_) { /* sem suporte */ }
}
